import API from '../API/Api';
import validacoes from './../libs/Validacoes';
import moment from 'moment-timezone';
import { isObject, isEmpty, cloneDeep } from "lodash"


let asktopromo = false;

const services = {
  setUser: function (dados, token) {
    localStorage.setItem('@systemdelivery:dataclient', dados);
  },
  getUser: function () {

    let dataclient = localStorage.getItem('@systemdelivery:dataclient');
    if (dataclient) {

      return JSON.parse(dataclient);
    }
    else {
      return false;
    }
  },

  setAskPromo: (toset) => {
    asktopromo = toset;
    return
  },

  askPromo: () => {
    return asktopromo;
  },

  getMaiorPreco: (objProdutos) => {
    const maior = objProdutos.sort((a, b) => {
      return b.PRECO - a.PRECO;
    })[0];
    return maior;
  },

  getMediaPreco: (objProdutos) => {
    if (!objProdutos) return;

    const qt = objProdutos.length;

    if (qt === 0) return 0;

    const total = objProdutos.reduce((total, item) => {
      return total += item.PRECO;
    }, 0)

    const media = Math.floor(total / qt);

    return media;
  },

  atualizaInfoCliLogado: function (data) {
    try {

      let user = this.getUser();

      user.dados_cli.nome_completo = data.nome_completo;
      user.dados_cli.email = data.email;
      user.dados_cli.ddd1 = data.ddd;
      user.dados_cli.telefone1 = data.telefone;

      if (!isEmpty(data.endereco)) {
        const auxEnderecos = cloneDeep(user.enderecos);
        const index = auxEnderecos.findIndex(e => e.id_endereco === data.endereco.id_endereco);

        if (index !== - 1) {
          user.enderecos[index].logradouro = data.endereco.logradouro;
          user.enderecos[index].cep = data.endereco.cep;
          user.enderecos[index].numero = data.endereco.numero;
          user.enderecos[index].bairro = data.endereco.bairro;
          user.enderecos[index].cidade = data.endereco.cidade;
          user.enderecos[index].estado = data.endereco.estado;
          user.enderecos[index].complemento = data.endereco.complemento;
          user.enderecos[index].longitude = data.endereco.longitude;
          user.enderecos[index].latitude = data.endereco.latitude;
          user.enderecos[index].ponto_referencia = data.endereco.ponto_referencia;
          user.enderecos[index].descricao = data.endereco.descricao;
          user.enderecos[index].principal = data.endereco.enderecoPrincipal;
        }

        if (data.endereco.enderecoPrincipal) {
          user.enderecos.map((e, indexMap) => {
            if (indexMap !== index) {
              user.enderecos[indexMap].principal = false;
            }
          })
        }

      }

      this.setUser(JSON.stringify(user));
    } catch (error) {
      console.log(error)
    }

  },

  formatDate: function (data) {
    try {

      const novoDado = moment(data).format("DD/MM/YYYY HH:mm");
      return novoDado;//moment.utc(data).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')

    } catch (error) {
      console.log(error);
      return data;
    }
  },

  enviaPedido: async function (pedido, token) {
    try {

      let headers = {
        "Content-Type": " application/json",
        "token": token
      };

      if (headers) {
        let body = { "pedido": pedido };
        let r = await API.put('pedidos', body, { headers: headers });
        return r;
      } else {
        return false;
      }

    } catch (error) {
      console.log(error + 'Envia Pedido');
      return false;

    }
  },

  enviaPedidoEstouNaMesa: async function (pedido, token) {
    try {

      let headers = {
        "Content-Type": " application/json",
        "token": token
      };

      if (headers) {
        let body = { "pedido": pedido };
        let r = await API.put('pedidosEstouNaMesa', body, { headers: headers });
        return true;
      } else {
        return false;
      }

    } catch (error) {
      console.log(error + 'Envia Pedido');
      return false;

    }
  },


  getItensMesaFromApi: async function (body) {
    try {
      let headers = { "Content-Type": " application/json" };
      if (headers) {

        let r = await API.post(`itensmesa`, body, { headers: headers });

        console.log(JSON.stringify(r.data.itens))
        return r.data.itens;
      } else {
        return false;
      }

    } catch (error) {
      console.log(error + 'getItensMesaFromApi');
      return false;

    }
  },





  enviaLinkEsqueciSenha: async function (email) {
    try {
      let headers = { 'Content-Type': 'application/json' };
      let response = await API.get(`linkesqueciminhasenha/${email}`, { headers: headers });
      if (response.status === 200) {
        return { err: false }
      } else {
        return { err: true }
      }
    } catch (error) {
      return { err: true }
    }

  },



  returnNextStore: async function (arrLojas, cep) {
    let result = [];
    let headers = { 'Content-Type': 'application/json' };

    if (cep && arrLojas) {

      for (let i = 0; i < arrLojas.length; i++) {
        try {
          let loja = arrLojas[i]
          let response = await API.get(`isatendido/${cep}/${loja.id_loja}`, { headers: headers });
          if (response.data.taxa) {
            loja.taxa_entrega = response.data.taxa;
            result.push({
              ...loja,
              TAXA: response.data.taxa
            });
          }
        } catch (error) {
          console.log(error)
        }
      }
    }

    return result;
  },


  // returnNextStore: function (arrLojas, endereco, kmMax) {
  //     let result = [];
  //     const { latitude: Mylatitude, longitude: Mylongitude } = endereco;
  //     if (Mylatitude && Mylongitude && arrLojas) {
  //         arrLojas.forEach(element => {
  //             if (this.getDistance(Mylatitude, Mylongitude, element.latitude, element.longitude) <= kmMax) {
  //                 result.push(element);
  //             }
  //         });
  //     }

  //     return result;
  // },

  consultaCep: async function (cep) {

    let result = {};
    try {
      let validaCep = validacoes.validaCEP(cep)
      if (validaCep) {
        result = await this.getCep(cep);
      }
    } catch (error) {
      console.log(error);
    }

    return result;
  },

  getTempPedido: function () {
    let r = [];
    r = localStorage.getItem('@systemdelivery:temp');
    return r;
  },

  setLastStore: function (data) {

    if (data) {
      localStorage.setItem('@systemdelivery:tempLastStore', data);
    }
  },

  getLastStore: function () {

    let r = {};

    r = localStorage.getItem('@systemdelivery:tempLastStore');

    try {
      r = JSON.parse(r);
    } catch (error) {
      r = {};
    }

    return r;
  },

  setLogado: function (logado) {

    localStorage.setItem('@@systemdelivery:logado', logado);
  },

  getLogado: function () {
    let logado = false;
    logado = localStorage.getItem('@@systemdelivery:logado');
    return logado === 'true';
  },

  setTempPedido: function (itens) {
    if (itens) {
      localStorage.setItem('@systemdelivery:temp', itens);
    }
  },

  cleanTemps: function () {
    localStorage.removeItem('@systemdelivery:temp');
    localStorage.removeItem('@systemdelivery:tempLastStore');
    localStorage.removeItem('@systemdelivery:tempLastStore');
  },

  totalizaItens: function (itensPedido, taxa, callback, withoutCallback) {

    let err = false;
    let response = {};

    try {
      let subtotal = itensPedido.reduce((total, element) => {
        return total + (element.total);
      }, 0);

      let tot = subtotal + taxa;


      if (subtotal === 0) tot = 0;

      response = {
        data: {
          total: tot,
          subtotal: subtotal

        }
      };


    } catch (error) {
      err = true;
      if (!withoutCallback) callback(err, response)
      else {
        return response
      }
    }


    if (!withoutCallback) callback(err, response)
    else {
      return response
    }
  },



  getActualTotal: function () {
    let data = {};
    try {
      data = localStorage.getItem('@systemdelivery:actualtoal');
      if (!data) {
        data = {
          total: '0',
          subtotal: '0'
        }
      }
      return data;
    } catch (error) {
      data = {
        total: '0',
        subtotal: '0'
      }
      return data;
    }
  },

  getAllProducts: async function (loja) {
    try {

      //let token = user.token;
      //let body = { token: token };
      let headers = { "Content-type": "application/json" }

      let r = await API.get(`categoriasinnerprods/${loja}`, { headers: headers });

      return r

      let user = this.getUser();
      if (user && 'token' in user) {

        let token = user.token;
        let body = { token: token };
        let headers = { "Content-type": "application/json", "token": token }

        let r = await API.get(`categoriasinnerprods/${loja}`, { headers: headers });

        return r;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
      return [];
    }
  },


  getHeadersAndCli: function () {

    let user = this.getUser();

    if (user && 'token' in user) {
      let token = user.token;
      let headers = { "Content-type": "application/json", "token": token }
      return { headers: headers, id_cliente: user.dados_cli.id_cliente };
    } else {
      return;
    }
  },

  getItensPedido: async function (codigo_pedido) {
    try {
      let headers = this.getHeadersAndCli();
      if (headers) {
        let r = await API.get(`itenspedido/${codigo_pedido}`, { headers: headers.headers });
        return r.data.itens;
      } else {
        return []
      }
    } catch (error) {
      console.log(error);
      return []
    }
  },



  registerAdress: async function (body) {
    try {
      let headers = this.getHeadersAndCli();
      if (headers) {
        const response = await API.post(`cliente/registerAdress`, body, { headers: headers.headers });

        if (response.status === 200) {
          return {
            status: 200,
            id_endereco: response.data.id_endereco
          }
        } else {
          return {
            status: 500
          }
        }
      } else {
        return {
          status: 500
        }
      }
    } catch (error) {
      console.log(error);
      return {
        status: 500
      }
    }
  },




  deleteAdress: async function (body) {
    try {
      let headers = this.getHeadersAndCli();
      if (headers) {
        const response = await API.post(`cliente/deleteadress`, body, { headers: headers.headers });

        if (response.status === 200) {
          return {
            status: response.data && response.data.codeError ? response.data.codeError : 200,
          }
        } else {
          return {
            status: response.data && response.data.codeError ? response.data.codeError : 500,
          }
        }
      } else {
        return {
          status: 500
        }
      }
    } catch (error) {
      console.log(error);
      return {
        status: 500
      }
    }
  },



  verficaLojaAberta: async function (loja) {
    try {
      let r = await API.get(`verificalojaaberta/${loja}`);

      return r.data.open;
    } catch (error) {

      console.log(error);
      return false
    }

  },


  importaCeps: async function (ceps) {
    try {
      let headers = this.getHeadersAndCli();
      if (headers) {
        let r = await API.post(`importaceps`, ceps);
        return r.data;
      } else {
        return []
      }
    } catch (error) {
      console.log(error);
      return []
    }

  },


  getTiposPags: async function (loja) {
    try {

      let headers = this.getHeadersAndCli();
      if (headers) {
        let r = await API.get(`tipopags/${loja}`, { headers: headers.headers });
        return r.data;
      } else {
        return []
      }
    } catch (error) {
      console.log(error);
      return []
    }

  },


  atualizaSenha: async function (id, senha, token) {
    try {

      let headers = {
        'Content-Type': 'application/json',
        'token': token
      };
      let body = { id: id, senha: senha };
      let r = await API.post('cliente/atualizasenha', body, { headers: headers });
      if (r.status === 200) {
        return { err: false }
      } else {
        return { err: true }
      }

    } catch (error) {
      console.log(error);
      return { err: true }
    }
  },


  validaToken: async function (token) {
    try {

      let headers = { 'Content-Type': 'application/json' };
      let body = { token: token };

      let r = await API.post('validaToken', body, { headers: headers });


      if (r.data.auth) {
        return { id: r.data.id };
      } else {
        return {}
      }


    } catch (error) {
      console.log(error);
      return {}
    }
  },

  getHistorico: async function () {
    try {
      let headers = this.getHeadersAndCli();
      if (headers) {
        let r = await API.get(`historicopedidos/${headers.id_cliente}`, { headers: headers.headers });
        return r.data.historico;
      } else {
        return []
      }
    } catch (error) {
      console.log(error);
      return []
    }
  },

  getStatusPedido: async function (codigo_pedido) {
    try {

      let user = this.getUser();
      if (user && 'token' in user) {
        let token = user.token;
        let body = { token: token };
        let headers = { "Content-type": "application/json", "token": token }
        let r = await API.get(`status_pedido/${codigo_pedido}`, { headers: headers });
        return r.data;
      } else {
        return {};
      }

    } catch (error) {
      console.log(error);
      return {};
    }
  },

  getExtras: async function (id_loja) {

    try {
      let headers = { "Content-type": "application/json" };

      let r = await API.get(`prodextras/${id_loja}`, { headers: headers });
      return r;

    } catch (error) {
      console.log(error);
      return [];
    }

  },

  getTemplateExtras: async function () {

    try {
      let headers = { "Content-type": "application/json" };

      const response = await API.get(`template_extras`, { headers: headers });
      return response.data.templates;

    } catch (error) {
      return [];
    }

  },

  getMassasAndBordas: async function () {

    try {
      let headers = { "Content-type": "application/json" };

      let r = await API.get('massasandbordas', { headers: headers });
      return r;

      let user = this.getUser();
      if (user && 'token' in user) {
        let token = user.token;
        let body = { token: token };
        let headers = { "Content-type": "application/json", "token": token };

        let r = await API.get('massasandbordas', { headers: headers });
        return r;
      }
    } catch (error) {
      console.log(error);
      return [];
    }

  },

  isLogado: async function () {

    try {
      let user = this.getUser();

      if (user && 'token' in user) {
        let token = user.token;


        let body = { token: token };
        let headers = { "Content-type": "application/json" }
        let r = await API.post('validaToken', body, { headers: headers });

        if (r.data.auth) {
          return true;
        } else {
          return false;
        }

      } else {
        return false;
      }

    } catch (e) {
      console.log(e);
      return false;
    }

  },

  getCep: async function (CEP) {
    let headers = { "Content-type": "application/json" }
    let result = {};
    try {


      let r = await API.get(`cep/${CEP}`, { headers: headers });
      return r.data;
    } catch (e) {

      if (e && 'response' in e) {
        if (e.response.status === 401)
          return {}
      } else if (e.status === 500) {
        return {}
      } else {
        return {}
      }

    }
  },

  logoutUser: function (where) {
    localStorage.removeItem('@systemdelivery:dataclient');
    if (where === 'principal') {
      window.location.reload();
    } else {
      document.location.href = "/";
    }
  },


  getDistance: function (lat1, lon1, lat2, lon2) {
    /**Forma de usar o getDiscante
 * 
 * getDistance({lat: -23.522490, lng: -46.736600}, {lat: -23.4446654, lng: -46.5319316}
 * 
 */
    var rad = function (x) { return x * Math.PI / 180; }
    var R = 6378.137; //Radio de la tierra en km
    var dLat = rad(lat2 - lat1);
    var dLong = rad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d.toFixed(3); //Retorna tres decimales
  }

}

export default services;